/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import { FETCH_SDCCA_PAYMENTS } from './actionTypes';

/**
 * Updates the details in the 'SDCCAPayments' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdccaPaymentsReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SDCCA_PAYMENTS);

/**
 * Updates the indicator of creation of details in the 'SDCCAPayments' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdccaPaymentsReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SDCCA_PAYMENTS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdccaPaymentsErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SDCCA_PAYMENTS);

const reducers = combineReducers({
  fetchSdccaPayments: fetchSdccaPaymentsReducer,

  isFetchingFetchSdccaPayments: isFetchingFetchSdccaPaymentsReducer,
  fetchSdccaPaymentsError: fetchSdccaPaymentsErrorReducer,
});

export default { reducers };
